import type { SocialMediaShareType } from '~/modules/moodboards/config';
import { addUtmData } from '~/modules/tracking/util/websiteTracking';
import type { User } from '~/server/types';

export interface AddUtmDataToShareUrlProp {
    url: string;
    socialType?: SocialMediaShareType;
    pageID: number;
    user: Pick<User, '__typename' | 'ID'>;
}

export const addUtmDataToShareUrl = ({
    url,
    socialType,
    pageID,
    user,
}: AddUtmDataToShareUrlProp): string => {
    const userID =
        user.__typename === 'Me' ? user.ID.toString() : `-${user.ID}`;
    const newURL = addUtmData(new URL(url), {
        utm_campaign: 'archipro_share',
        utm_source: socialType
            ? socialType !== 'copyLink'
                ? socialType
                : 'archipro'
            : '',
        utm_content: `${userID}_${pageID}`,
        utm_medium: '',
    }).toString();
    return newURL;
};
